module.exports = __webpack_public_path__ + "img/20240914_2.3355dea7.jpg";